import {Button, Form, Input, Select} from "antd";
import React from "react";

const FilterForm = ({form, tableParams, onFilterFinish, filterConfig}) => {
    return (
        <Form
            form={form}
            layout="inline"
            initialValues={tableParams.filters}
            style={{ marginBottom: 16, marginTop: 16 }}
            onFinish={onFilterFinish}
        >
            {filterConfig.map((conf) => {
                if (conf.type === 'select') {
                    return (
                        <Form.Item name={conf.name} key={conf.name}>
                            <Select placeholder={conf.placeholder} style={{ width: conf.width || 200 }} allowClear={true} >
                                {conf.options.map((opt) => (
                                    <Select.Option value={opt.value} key={opt.value}>
                                        {opt.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    );
                }
                if (conf.type === 'input') {
                    return (
                        <Form.Item name={conf.name} key={conf.name}>
                            <Input placeholder={conf.placeholder} style={{ width: conf.width || 200 }} allowClear/>
                        </Form.Item>
                    );
                }
                return null;
            })}
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Filter
                </Button>
            </Form.Item>
        </Form>
    )
};

export default FilterForm;